import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  Button,
  Paper,
  Alert,
  CircularProgress,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { MasterType, masterTypeLabels, MasterDataType } from '../types/master';
import CountryMasterTab from '../components/master/CountryMasterTab';
import RegionMasterTab from '../components/master/RegionMasterTab';
import AreaMasterTab from '../components/master/AreaMasterTab';
import DistrictMasterTab from '../components/master/DistrictMasterTab';
import CategoryMasterTab from '../components/master/CategoryMasterTab';
import SubcategoryMasterTab from '../components/master/SubcategoryMasterTab';
import DetailedTypeMasterTab from '../components/master/DetailedTypeMasterTab';

/**
 * マスタデータ管理ページ
 */
const MasterData: React.FC = () => {
  const [currentTab, setCurrentTab] = useState<MasterType>('countries');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const functions = getFunctions();

  const handleTabChange = (_event: React.SyntheticEvent, newValue: MasterType) => {
    setCurrentTab(newValue);
    setError(null);
    setSuccess(null);
  };

  const renderTabContent = () => {
    switch (currentTab) {
      case 'countries':
        return (
          <CountryMasterTab
            onError={setError}
            onSuccess={setSuccess}
          />
        );
      case 'regions':
        return (
          <RegionMasterTab
            onError={setError}
            onSuccess={setSuccess}
          />
        );
      case 'areas':
        return (
          <AreaMasterTab
            onError={setError}
            onSuccess={setSuccess}
          />
        );
      case 'districts':
        return (
          <DistrictMasterTab
            onError={setError}
            onSuccess={setSuccess}
          />
        );
      case 'categories':
        return (
          <CategoryMasterTab
            onError={setError}
            onSuccess={setSuccess}
          />
        );
      case 'subcategories':
        return (
          <SubcategoryMasterTab
            onError={setError}
            onSuccess={setSuccess}
          />
        );
      case 'detailedTypes':
        return (
          <DetailedTypeMasterTab
            onError={setError}
            onSuccess={setSuccess}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" component="h1">
          マスタデータ管理
        </Typography>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess(null)}>
          {success}
        </Alert>
      )}

      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="国マスタ" value="countries" />
          <Tab label="地方マスタ" value="regions" />
          <Tab label="エリアマスタ" value="areas" />
          <Tab label="地区マスタ" value="districts" />
          <Tab label="業種マスタ" value="categories" />
          <Tab label="業種詳細マスタ" value="subcategories" />
          <Tab label="店舗タイプマスタ" value="detailedTypes" />
        </Tabs>
      </Paper>

      <Paper sx={{ p: 3 }}>
        {renderTabContent()}
      </Paper>
    </Container>
  );
};

export default MasterData;
